
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/legal/recurring",
      function () {
        return require("private-next-pages/[lang]/legal/recurring/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/legal/recurring"])
      });
    }
  